'use client';

import VideoPlayer from '../../VideoPlayer';
import VideoPreview from '../VideoPreview/VideoPreview';
import VideoControls from '../VideoControls/VideoControls';
import { VideoItemReference } from 'types/sharedComponents';

interface FullBleedVideoPlayerProps {
  video: VideoItemReference;
}

const FullBleedVideoPlayer = ({ video }: FullBleedVideoPlayerProps) => {
  return (
    <div className="absolute w-full h-full overflow-hidden">
      <VideoPlayer
        video={video}
        autoPlay
        muted
        loop
        playInBackground
        hideNativeControls
        testId="full-bleed-video-player"
        classNames={{
          wrapper: 'w-full h-full',
          player: 'object-cover',
        }}>
        <VideoPreview image={video.previewImage} showPreviewOnEnd={false} />
        <VideoControls hideOnVideoStarted={false} />
      </VideoPlayer>
    </div>
  );
};

export default FullBleedVideoPlayer;
